import styled from "styled-components";

export const DivStyled = styled.div`
  width: 100%;
  margin-left: 50px;
`

export const MessageInput = styled.span`
  font-size: 12px;
  font-weight: 325;
  line-height: 15.6px;
  text-align: left;
  color: #A30000;
`